var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { createMachine, assign } from "xstate";
import Cookies from "js-cookie";
import { Routes } from "../types/routes";
export var routingMachine = createMachine({
    /** @xstate-layout N4IgpgJg5mDOIC5QCcD2BXALgSwHZQFkBDAYwAs8wA6CMTMZAW0oEldsciAbAZUyPoBiANoAGALqJQAB1SwO2VLikgAHogC0ARgAsWgBxUArDp0BmUQE5LZvfrMB2ADQgAnokeiqOhw4uX9IyMAJn1LADZwgF8olzQsPEJSClxqWnomVnZOXn4hYS1JJBBZeRwlFXUEbTtjU38bO0cXdwQdUO9ff0CQsMiYuIwcfGJySho6BmZUtgVuPgEwEWCimTkFCuKqmoM68ytGg2a3RBMdTr8rHtCIgZB44aSx1ImM6bBZnIX8s1WS9fKyi2ml0uzODVsR2cJwQ4VEwQu3SCN2isXuQ0SoxSaUmmRm2Ww8zyS2EOj+pQ2QNA21BhnBB0h9mhrUiXh8lwCyL6dwemOS43SUyyc1yixERnJAMUVLUINq9OsjOOrQcu3ZSN6tzRvJG-JegrxHwJRLFwnCkrK0sqcrB9QZTWZiF84URVy5WsGCV1zxxb2FX2JIgcFsp1uqtL2EIdLUQ9nO6rdmtRnseWIFuPen0Jovy+hDgLDOzpdsV0ZhYQRCc5SZ5GO92KosH4yEwGi4qCIuEE8iguDYACEsJglAAFZBwWBifNW4HhnSWBxUSxaGz2qEx8PhIxUByWIxmLeWUyWYJGey1r1PBtNogttsdrvjgBmDGQ3AAKtgSABrOgAUUYIhsC4P9VGwJsAHUODIABVWAGCnFQKQLWcagXJcVyjdcYQ0YItDMHc9wPIwj3nU9z21Osr3GG873bTtBGfV8Py-X9MAAoCQLAyDoKGOCEIkJCpU2ak5XQ5dV1LbDWlw8ItEI-dD2PcizAvVM9WoWjW3ortYHQAAjZh2MA4DEOKZCZ1E8NemMYJTzOcIDyscIN20LRF13RSSOUs9VMoy80xeLT7wYvTDI4DjTMKITLRE2VrOCRdglEM9LHhEiLHcjdt3CBxAmCMwTHCYIInCHQgjUvkfUbZttIfbsDKMyKuCgzAyAANQYbAn2wSAAEEsDIUQ+pIEgMFwTA+twCAADlUAACSIPS3zMtZYplGl50XCSsKZVz-AU4jSJPXzKvrGjapC3TGoikyWugubcE65But6iABra4bRvGybprmxblqIVb-nWwtdHEzC1z2nDCo8oilLI07-PU6rgp0hrwswAB5XAFhbAAZB9gYsuKaX3BETx0LdRDyhwDg3fDFy0SI0rhQr9BpuyzuooLLvRsKjJxvHMEJzsCmnUmQRCbd9AcIxma0LRkt3XwN2CYqqDMawDB0a4+mTdEAo0mrbzq0Kbux3HatF3BhBWGLQ1Q8HtshqToZknQUsOhGToolMqobEguCAxgrsEdsoCGYnhI2uV5yoJXgnMeclUdBA9zZLpExRbnAuoIOQ7DgWOHoCAAGFg+wRgbZ4dBRonfjkFA8DMGj0GnePBO7OTw53cQLRRCVpcs+rHPkYD8YC6rouLdLiuQ5ruuSAb+DkAAEVQOA5vY7jW8E8yY7BzvE571OGaV+SUpMWw9Y9Q2UcDyvQ-52fIHnqvF-r2BYEbwmoBgCAbA26OysjUeOJ9bC92VP3OylgE5mEKiRW+BsdQ83zk-NsnYICJHDqgSOWBgEoVAbocB3dIFnxhPhRwVA8LM30Lrd0KCqJ5yoGQMAXB2waDALvRIGgiDSGkFwL8AhpS4PwXvCWsdqgOBKgnFWkQjDhGXPQswatcrD2ZqIUQVN9xmH0MzXOxs2EcNQBoVIAB3PhAihEkBEUoDGRl5rsPbDNMA5i+rWOEYCQhll4oaF3IYU8J4ZFy2sL4LQDMSJUDCLYOWOiEH6L8v7c6LxjGcIsVYwRXjRERyjvvNaIC-FywIo4doZgCp6ACC5GECDM6aO0VuBJBjx4pM0tgXsGg8DdnaX2XAg5MDDlwGOCcPjJbSPsDuYiSjfCpRSq5JO25yrWD3APA8kQtCGNRj0zpXYg6sRxgAMVQMgSOmARxLVgOY45EBRlSI0DEqgogDz6H0CVUQ9htHBFckEJcNMXnlS0CYFKisjCbOvNsrpSg-54Frl-WAT50BcFuYWJk8CrBGFVAPLcfgNxyRoaEOykRypBFKmCmiEKuzoFXtvMuSgepMEgKBZe0hvH5JBoU7YeUXTLhproOmcIbARJwroQwrzAX4R8IrRK5UyVBQpYIKlDBm5NlgFNCAAN8ZgCIDctlJM7m7gIuCF5aUFwGDTtodCSzrDyyeZEOSsq2kdK6T2XAMFpD9MGcM7+yLUJ5QIn4Lc0y5ZhDmThEqBErUrNtesh1jZ5UurYLC5e38EVcCOcgd+1cia6sPr6iZAbFELmDWlIwG4tYU1VHCBpuj9FMKNlsp1XZ9KkG-O+VAwsbY+tAX6yZgai2zNLTDPQ3gSLWtWXajZLS0Fxo6egaQ3TewDiHKOcc3qc3t1AZ7Lw+g5L7iMFYQFLzqksnknZV56sypBBIv0KdLCXUaDnQ4jgPAeluq7X4gqXh5Zbppr5DKadFZwOZoVJWog5LtG0aC29xt72PuLpgF9vY3WtTIJm99NILCa2XICxK+6Di6zVolGhehHL8t0MlGV0GG24AffOvZP5DnHNOec7+VzkA6skWDTDWsQW4a0dYAjMJVQJ0cvLZK4GKNQeSdO2D87m0-jbYh3p6GQTcewyEOW-Gjz6DVgRYDYmwPke0brWNsmNAADcupPlcHw766AJoLt6R6ldIz12FNaIrQwWstEOHKuYdyAQXBVFsC6TzZqrgKP0KZ7Zc6LNWZs6QMa9nMCCDGrQZ6r1IAHLQIwNe3UXzjgmjwCc0oVMIBCwnAw4Wqlbh00Jrw3maZ+bMAFqLVHwWzukHFl61nbNJYc2lsAGWepZZyzwIgjAwDFe-qVtzRD4oVbC7LCLtWGYc2iWlJr19WvRc6917qCW7MDdQOlqzb1suoEYONyb035BKBQ2hubvjgtU0q-o5bNWzxq3MFhnzzWdvtfGE+JjqBWzSAuWxiAjml0DJc2uzjqEEHbgiA05WdDtEAYKjuAlF7iXXrrQ-IHIOwcQ+uY5t1zmhmrsnE9sZGgkdLjhFTNH4QOY+DWy6M9hLL0kpvdJlhwOTmg40OD1jZP4PpuY6T9jzUyv08Koz1HvLWcY-mQEBOEldb6KVoo2NgvTki+l1D+Trb209KAbTu5DOUfM+V2ztOSdDAyPPUSq9pLAcvH18L0Xlzrk7OkFgDQg3od9OXVT1zCPiEHgIilUsUCAMIKSorVnDCawe+oF7knYv2P+8D8HzPLHffscG7XTGpc5f4Uco80d5Cywea1nAzFKfkF6+J4b7PEBc+tnz8TwvkOS+vwgA9p+Ffo-V7jxQjz+6PJhA5qPbk6eqD6SpZQb+OzBeAUBGIvJke-Ggm3JWnW8eGa7uiblRoLfF9MWQG+LgAB6EgwQSCpafwAJTAAV2-rjzGNwrww7wtex+lCuUXm5+N8jCsa1+t+D+T+L+JA7+n+3Ayqjwv+luR8gQABKcWB0k-cXK3gVMsel+-OxsUB3AMBz+j+8BH+zEXAtKE0eA6AYAf+GBp82BfcCABgR4tkdgqeY8xB1UpB9+lBIelOXqNOu+m0LBgBk+-ce4i48IPBRB98E8Lwgh5B2+BCaBHcUhWBQBrQyUK43BOsl+aIuAJ2cAKgqCecDs82NIvgXgYSrBOB1QKcNC8MgKeih4uui+BomYxoOYYANhz2IIMiFMC4Th7B7MWGyivBYQDgkBqAoOQRdOcI24BUiis+sCNguKp6OOruvOBOKhmkfMD4yRdy7kdkS44Rtezh-iLo7yicjMDgZUJUUmyhrSVAU8z8pRB8G6e+oRVRvmNR7BvmCIDexh7o8Ri+XRmC00iQZRYMAxjhwx0C6cWOYQMRt8bW-BDYaSpi3CLcvC-CWSti82eqYMYG3KJ4F6haOsqiMI6s8kxUGKmUjSbOsaexZibimSNidiMo5xTsYG5wpSBUFSK4O6DMB4WGsSjgisqoIQu2NGeACxgJGKVAckgKQaA6G45wcs+4-yAQeJssUxOx5KnWKJm62iNC6yGmeG1q8y+6GuK4WuUqJKJJ7RMmMWXWlmPWh2-WmAFJ8USc0SKUrOdMn2rydWHmuwjWvm22ASreQuWeReEAgp2wckXgTygQy2laHMg6MkGsyU+iYGXKckMai+me7eKpXeQe5hapIRlRyxbBqxisXs4x9CWxsay+8gqQa+eAG+fx9p4YSx1RzpmOO6G2mx7o2xHJLCahlBQZ2gIZQxYZDMVMXm2sHp0ZMQMQQAA */
    tsTypes: {},
    id: "routingMachine",
    initial: "determineInitialState",
    schema: {
        events: {},
    },
    context: {
        query: undefined,
        router: null,
        runtimeInitialState: undefined,
        user: null,
    },
    states: {
        determineInitialState: {
            always: [
                {
                    target: "start-loan",
                    cond: function (context) {
                        return context.runtimeInitialState === "start-loan" ||
                            context.runtimeInitialState === "root";
                    },
                },
                {
                    target: "claim-loan",
                    cond: function (context) { return context.runtimeInitialState === "claim-loan"; },
                },
                {
                    target: "claim-landing",
                    cond: function (context) { return context.runtimeInitialState === "claim-landing"; },
                },
                {
                    target: "hello-existing-application",
                    cond: function (context) {
                        return context.runtimeInitialState === "hello-existing-application";
                    },
                },
                {
                    target: "hello-new-application",
                    cond: function (context) {
                        return context.runtimeInitialState === "hello-new-application";
                    },
                },
                {
                    target: "sign-up-verify-account",
                    cond: function (context) {
                        return context.runtimeInitialState === "sign-up-verify-account";
                    },
                },
                {
                    target: "referral/c2c",
                    cond: function (context) { return context.runtimeInitialState === "referral/c2c"; },
                },
                {
                    target: "forgot-password",
                    cond: function (context) {
                        return context.runtimeInitialState === "forgot-password";
                    },
                },
            ],
        },
        root: { entry: "redirect" },
        "start-loan": {
            always: [
                {
                    target: "claim-landing",
                    cond: "hasClaimingEmailCookie",
                },
            ],
            on: {
                submitEmailWithNonVerifiedAuth0AccountAndNoHasura: {
                    target: "sign-up-verify-account",
                    actions: "assignEmailQueryString",
                },
                submitEmailWithHasuraUserWithCognitoIdAndNoAuth0Id: {
                    target: "forgot-password",
                    actions: "assignRedCarpetCopyFlag",
                },
                submitOnStartLoan: [
                    {
                        cond: "userIsSignedIn",
                        target: "business-information",
                    },
                    {
                        cond: "userHasNoExistingLeads",
                        target: "hello-new-application",
                        actions: "assignEmailQueryString",
                    },
                    {
                        target: "hello-existing-application",
                        actions: "assignEmailQueryString",
                    },
                ],
            },
        },
        "forgot-password": {
            entry: "redirect",
        },
        "claim-loan": {
            entry: "redirect",
            on: {
                logout: {
                    target: "start-loan",
                },
                submittedClaimLoanSuccessUserLoggedIn: {
                    target: "claim-landing",
                    actions: "assignClaimLoanQueryString",
                },
            },
        },
        "claim-landing": {
            entry: "redirect",
            on: {
                logout: {
                    target: "start-loan",
                },
            },
        },
        "hello-existing-application": {
            entry: "redirect",
            on: {
                logout: {
                    target: "start-loan",
                },
            },
        },
        "hello-new-application": {
            entry: "redirect",
            on: {
                logout: {
                    target: "start-loan",
                },
            },
        },
        "sign-up-verify-account": {
            entry: "redirect",
        },
        "business-information": {
            entry: "redirect",
            on: {
                logout: {
                    target: "start-loan",
                },
            },
        },
        "referral/c2c": {
            on: {
                c2cReferralContinue: {
                    target: "business-information",
                },
                logout: {
                    target: "start-loan",
                },
            },
        },
    },
}, {
    guards: {
        userIsSignedIn: function (context) {
            var isSignedIn = context.user !== undefined;
            return isSignedIn;
        },
        userHasNoExistingLeads: function (context, event) {
            return event.data.userHasNoExistingLeads;
        },
        hasClaimingEmailCookie: function (context) {
            if (context.router.pathname.includes(Routes.SignUpVerifyAccount)) {
                return false;
            }
            var hasClaimCookie = Cookies.get("ClaimingApplicationEmail") !== undefined;
            return hasClaimCookie;
        },
    },
    actions: {
        redirect: function (context, event, meta) {
            var pathname = meta.state.value === "root"
                ? "/"
                : "/".concat(meta.state.value);
            var allQueryParams = __assign(__assign({}, context.query), context.router.query);
            // Remove the redirect parameter to avoid infinite redirects
            // eslint-disable-next-line @typescript-eslint/no-unused-vars
            var redirect = allQueryParams.redirect, queryWithoutRedirect = __rest(allQueryParams, ["redirect"]);
            context.router.push({
                pathname: pathname,
                query: queryWithoutRedirect,
            });
        },
        assignEmailQueryString: assign({
            query: function (context, event) {
                var query = {
                    email: event.data.email.replace("+", "%2B"),
                };
                return query;
            },
        }),
        assignClaimLoanQueryString: assign({
            query: function (context, event) {
                var query = {
                    email: event.data.email.replace("+", "%2B"),
                    sfApplicationId: event.data.sfApplicationId,
                };
                return query;
            },
        }),
        assignRedCarpetCopyFlag: assign({
            query: function (context, event) {
                var query = {
                    email: event.data.email.replace("+", "%2B"),
                    redCarpetCopy: true,
                };
                return query;
            },
        }),
    },
});
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoicm91dGluZ1N0YXRlTWFjaGluZS5qc3giLCJzb3VyY2VSb290IjoiIiwic291cmNlcyI6WyJyb3V0aW5nU3RhdGVNYWNoaW5lLnRzeCJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiOzs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7O0FBQUEsT0FBTyxFQUFFLGFBQWEsRUFBRSxNQUFNLEVBQUUsTUFBTSxRQUFRLENBQUM7QUFJL0MsT0FBTyxPQUFPLE1BQU0sV0FBVyxDQUFDO0FBQ2hDLE9BQU8sRUFBRSxNQUFNLEVBQUUsTUFBTSxpQkFBaUIsQ0FBQztBQUV6QyxNQUFNLENBQUMsSUFBTSxjQUFjLEdBQUcsYUFBYSxDQUN6QztJQUNFLCtxSUFBK3FJO0lBQy9xSSxPQUFPLEVBQUUsRUFBc0Q7SUFDL0QsRUFBRSxFQUFFLGdCQUFnQjtJQUNwQixPQUFPLEVBQUUsdUJBQXVCO0lBQ2hDLE1BQU0sRUFBRTtRQUNOLE1BQU0sRUFBRSxFQW1ESDtLQUNOO0lBQ0QsT0FBTyxFQUFFO1FBQ1AsS0FBSyxFQUFFLFNBQWdDO1FBQ3ZDLE1BQU0sRUFBRSxJQUFrQjtRQUMxQixtQkFBbUIsRUFBRSxTQUFtQjtRQUN4QyxJQUFJLEVBQUUsSUFBSTtLQUNYO0lBQ0QsTUFBTSxFQUFFO1FBQ04scUJBQXFCLEVBQUU7WUFDckIsTUFBTSxFQUFFO2dCQUNOO29CQUNFLE1BQU0sRUFBRSxZQUFZO29CQUNwQixJQUFJLEVBQUUsVUFBQyxPQUFPO3dCQUNaLE9BQUEsT0FBTyxDQUFDLG1CQUFtQixLQUFLLFlBQVk7NEJBQzVDLE9BQU8sQ0FBQyxtQkFBbUIsS0FBSyxNQUFNO29CQUR0QyxDQUNzQztpQkFDekM7Z0JBQ0Q7b0JBQ0UsTUFBTSxFQUFFLFlBQVk7b0JBQ3BCLElBQUksRUFBRSxVQUFDLE9BQU8sSUFBSyxPQUFBLE9BQU8sQ0FBQyxtQkFBbUIsS0FBSyxZQUFZLEVBQTVDLENBQTRDO2lCQUNoRTtnQkFDRDtvQkFDRSxNQUFNLEVBQUUsZUFBZTtvQkFDdkIsSUFBSSxFQUFFLFVBQUMsT0FBTyxJQUFLLE9BQUEsT0FBTyxDQUFDLG1CQUFtQixLQUFLLGVBQWUsRUFBL0MsQ0FBK0M7aUJBQ25FO2dCQUNEO29CQUNFLE1BQU0sRUFBRSw0QkFBNEI7b0JBQ3BDLElBQUksRUFBRSxVQUFDLE9BQU87d0JBQ1osT0FBQSxPQUFPLENBQUMsbUJBQW1CLEtBQUssNEJBQTRCO29CQUE1RCxDQUE0RDtpQkFDL0Q7Z0JBQ0Q7b0JBQ0UsTUFBTSxFQUFFLHVCQUF1QjtvQkFDL0IsSUFBSSxFQUFFLFVBQUMsT0FBTzt3QkFDWixPQUFBLE9BQU8sQ0FBQyxtQkFBbUIsS0FBSyx1QkFBdUI7b0JBQXZELENBQXVEO2lCQUMxRDtnQkFDRDtvQkFDRSxNQUFNLEVBQUUsd0JBQXdCO29CQUNoQyxJQUFJLEVBQUUsVUFBQyxPQUFPO3dCQUNaLE9BQUEsT0FBTyxDQUFDLG1CQUFtQixLQUFLLHdCQUF3QjtvQkFBeEQsQ0FBd0Q7aUJBQzNEO2dCQUNEO29CQUNFLE1BQU0sRUFBRSxjQUFjO29CQUN0QixJQUFJLEVBQUUsVUFBQyxPQUFPLElBQUssT0FBQSxPQUFPLENBQUMsbUJBQW1CLEtBQUssY0FBYyxFQUE5QyxDQUE4QztpQkFDbEU7Z0JBQ0Q7b0JBQ0UsTUFBTSxFQUFFLGlCQUFpQjtvQkFDekIsSUFBSSxFQUFFLFVBQUMsT0FBTzt3QkFDWixPQUFBLE9BQU8sQ0FBQyxtQkFBbUIsS0FBSyxpQkFBaUI7b0JBQWpELENBQWlEO2lCQUNwRDthQUNGO1NBQ0Y7UUFFRCxJQUFJLEVBQUUsRUFBRSxLQUFLLEVBQUUsVUFBVSxFQUFFO1FBRTNCLFlBQVksRUFBRTtZQUNaLE1BQU0sRUFBRTtnQkFDTjtvQkFDRSxNQUFNLEVBQUUsZUFBZTtvQkFDdkIsSUFBSSxFQUFFLHdCQUF3QjtpQkFDL0I7YUFDRjtZQUNELEVBQUUsRUFBRTtnQkFDRixpREFBaUQsRUFBRTtvQkFDakQsTUFBTSxFQUFFLHdCQUF3QjtvQkFDaEMsT0FBTyxFQUFFLHdCQUF3QjtpQkFDbEM7Z0JBQ0Qsa0RBQWtELEVBQUU7b0JBQ2xELE1BQU0sRUFBRSxpQkFBaUI7b0JBQ3pCLE9BQU8sRUFBRSx5QkFBeUI7aUJBQ25DO2dCQUNELGlCQUFpQixFQUFFO29CQUNqQjt3QkFDRSxJQUFJLEVBQUUsZ0JBQWdCO3dCQUN0QixNQUFNLEVBQUUsc0JBQXNCO3FCQUMvQjtvQkFDRDt3QkFDRSxJQUFJLEVBQUUsd0JBQXdCO3dCQUM5QixNQUFNLEVBQUUsdUJBQXVCO3dCQUMvQixPQUFPLEVBQUUsd0JBQXdCO3FCQUNsQztvQkFDRDt3QkFDRSxNQUFNLEVBQUUsNEJBQTRCO3dCQUNwQyxPQUFPLEVBQUUsd0JBQXdCO3FCQUNsQztpQkFDRjthQUNGO1NBQ0Y7UUFFRCxpQkFBaUIsRUFBRTtZQUNqQixLQUFLLEVBQUUsVUFBVTtTQUNsQjtRQUVELFlBQVksRUFBRTtZQUNaLEtBQUssRUFBRSxVQUFVO1lBQ2pCLEVBQUUsRUFBRTtnQkFDRixNQUFNLEVBQUU7b0JBQ04sTUFBTSxFQUFFLFlBQVk7aUJBQ3JCO2dCQUNELHFDQUFxQyxFQUFFO29CQUNyQyxNQUFNLEVBQUUsZUFBZTtvQkFDdkIsT0FBTyxFQUFFLDRCQUE0QjtpQkFDdEM7YUFDRjtTQUNGO1FBRUQsZUFBZSxFQUFFO1lBQ2YsS0FBSyxFQUFFLFVBQVU7WUFDakIsRUFBRSxFQUFFO2dCQUNGLE1BQU0sRUFBRTtvQkFDTixNQUFNLEVBQUUsWUFBWTtpQkFDckI7YUFDRjtTQUNGO1FBRUQsNEJBQTRCLEVBQUU7WUFDNUIsS0FBSyxFQUFFLFVBQVU7WUFDakIsRUFBRSxFQUFFO2dCQUNGLE1BQU0sRUFBRTtvQkFDTixNQUFNLEVBQUUsWUFBWTtpQkFDckI7YUFDRjtTQUNGO1FBRUQsdUJBQXVCLEVBQUU7WUFDdkIsS0FBSyxFQUFFLFVBQVU7WUFDakIsRUFBRSxFQUFFO2dCQUNGLE1BQU0sRUFBRTtvQkFDTixNQUFNLEVBQUUsWUFBWTtpQkFDckI7YUFDRjtTQUNGO1FBRUQsd0JBQXdCLEVBQUU7WUFDeEIsS0FBSyxFQUFFLFVBQVU7U0FDbEI7UUFFRCxzQkFBc0IsRUFBRTtZQUN0QixLQUFLLEVBQUUsVUFBVTtZQUNqQixFQUFFLEVBQUU7Z0JBQ0YsTUFBTSxFQUFFO29CQUNOLE1BQU0sRUFBRSxZQUFZO2lCQUNyQjthQUNGO1NBQ0Y7UUFDRCxjQUFjLEVBQUU7WUFDZCxFQUFFLEVBQUU7Z0JBQ0YsbUJBQW1CLEVBQUU7b0JBQ25CLE1BQU0sRUFBRSxzQkFBc0I7aUJBQy9CO2dCQUNELE1BQU0sRUFBRTtvQkFDTixNQUFNLEVBQUUsWUFBWTtpQkFDckI7YUFDRjtTQUNGO0tBQ0Y7Q0FDRixFQUNEO0lBQ0UsTUFBTSxFQUFFO1FBQ04sY0FBYyxFQUFFLFVBQUMsT0FBTztZQUN0QixJQUFNLFVBQVUsR0FBRyxPQUFPLENBQUMsSUFBSSxLQUFLLFNBQVMsQ0FBQztZQUM5QyxPQUFPLFVBQVUsQ0FBQztRQUNwQixDQUFDO1FBQ0Qsc0JBQXNCLEVBQUUsVUFBQyxPQUFPLEVBQUUsS0FBSztZQUNyQyxPQUFPLEtBQUssQ0FBQyxJQUFJLENBQUMsc0JBQXNCLENBQUM7UUFDM0MsQ0FBQztRQUNELHNCQUFzQixFQUFFLFVBQUMsT0FBTztZQUM5QixJQUFJLE9BQU8sQ0FBQyxNQUFNLENBQUMsUUFBUSxDQUFDLFFBQVEsQ0FBQyxNQUFNLENBQUMsbUJBQW1CLENBQUMsRUFBRTtnQkFDaEUsT0FBTyxLQUFLLENBQUM7YUFDZDtZQUNELElBQU0sY0FBYyxHQUNsQixPQUFPLENBQUMsR0FBRyxDQUFDLDBCQUEwQixDQUFDLEtBQUssU0FBUyxDQUFDO1lBQ3hELE9BQU8sY0FBYyxDQUFDO1FBQ3hCLENBQUM7S0FDRjtJQUVELE9BQU8sRUFBRTtRQUNQLFFBQVEsRUFBRSxVQUFDLE9BQU8sRUFBRSxLQUFLLEVBQUUsSUFBSTtZQUM3QixJQUFNLFFBQVEsR0FDWCxJQUFJLENBQUMsS0FBSyxDQUFDLEtBQWdCLEtBQUssTUFBTTtnQkFDckMsQ0FBQyxDQUFDLEdBQUc7Z0JBQ0wsQ0FBQyxDQUFDLFdBQUksSUFBSSxDQUFDLEtBQUssQ0FBQyxLQUFlLENBQUUsQ0FBQztZQUV2QyxJQUFNLGNBQWMseUJBQ2YsT0FBTyxDQUFDLEtBQUssR0FDYixPQUFPLENBQUMsTUFBTSxDQUFDLEtBQUssQ0FDeEIsQ0FBQztZQUVGLDREQUE0RDtZQUM1RCw2REFBNkQ7WUFDckQsSUFBQSxRQUFRLEdBQThCLGNBQWMsU0FBNUMsRUFBSyxvQkFBb0IsVUFBSyxjQUFjLEVBQXRELFlBQXFDLENBQUYsQ0FBb0I7WUFFN0QsT0FBTyxDQUFDLE1BQU0sQ0FBQyxJQUFJLENBQUM7Z0JBQ2xCLFFBQVEsRUFBRSxRQUFRO2dCQUNsQixLQUFLLEVBQUUsb0JBQW9CO2FBQzVCLENBQUMsQ0FBQztRQUNMLENBQUM7UUFDRCxzQkFBc0IsRUFBRSxNQUFNLENBQUM7WUFDN0IsS0FBSyxFQUFFLFVBQUMsT0FBTyxFQUFFLEtBQUs7Z0JBQ3BCLElBQU0sS0FBSyxHQUFHO29CQUNaLEtBQUssRUFBRSxLQUFLLENBQUMsSUFBSSxDQUFDLEtBQUssQ0FBQyxPQUFPLENBQUMsR0FBRyxFQUFFLEtBQUssQ0FBQztpQkFDNUMsQ0FBQztnQkFDRixPQUFPLEtBQUssQ0FBQztZQUNmLENBQUM7U0FDRixDQUFDO1FBQ0YsMEJBQTBCLEVBQUUsTUFBTSxDQUFDO1lBQ2pDLEtBQUssRUFBRSxVQUFDLE9BQU8sRUFBRSxLQUFLO2dCQUNwQixJQUFNLEtBQUssR0FBRztvQkFDWixLQUFLLEVBQUUsS0FBSyxDQUFDLElBQUksQ0FBQyxLQUFLLENBQUMsT0FBTyxDQUFDLEdBQUcsRUFBRSxLQUFLLENBQUM7b0JBQzNDLGVBQWUsRUFBRSxLQUFLLENBQUMsSUFBSSxDQUFDLGVBQWU7aUJBQzVDLENBQUM7Z0JBQ0YsT0FBTyxLQUFLLENBQUM7WUFDZixDQUFDO1NBQ0YsQ0FBQztRQUNGLHVCQUF1QixFQUFFLE1BQU0sQ0FBQztZQUM5QixLQUFLLEVBQUUsVUFBQyxPQUFPLEVBQUUsS0FBSztnQkFDcEIsSUFBTSxLQUFLLEdBQUc7b0JBQ1osS0FBSyxFQUFFLEtBQUssQ0FBQyxJQUFJLENBQUMsS0FBSyxDQUFDLE9BQU8sQ0FBQyxHQUFHLEVBQUUsS0FBSyxDQUFDO29CQUMzQyxhQUFhLEVBQUUsSUFBSTtpQkFDcEIsQ0FBQztnQkFDRixPQUFPLEtBQUssQ0FBQztZQUNmLENBQUM7U0FDRixDQUFDO0tBQ0g7Q0FDRixDQUNGLENBQUMifQ==